import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  className,
  ...props
}) => {
  const defaultButtonStyling =
    "group bg-orange font-secondary text-white px-6 py-2 flex flex-row items-center text-center justify-center transition-all duration-350 hover:bg-grey uppercase";

  const buttonStyling = className
    ? `${defaultButtonStyling} ${className}`
    : defaultButtonStyling;
  return (
    <button className={buttonStyling} {...props}>
      {children}
    </button>
  );
};
